import { getStorage, SessionStorage } from "@/utils/storage";
import { checkEnableInsure, getInsureId } from "../api/request/snkd.produce";

export default {
  data() {
    return {
      // 分页数据
      total: 0, // 总条数
      pageSize: 20, // 每页数量
      pageNo: 1, // 当前页面
      companyId: getStorage("FARMINFO").companyId, // 企业id
      farmId: getStorage("FARMINFO").farmId, // 农场id
      insureInfo: {},
    };
  },

  mounted() {
    this.paddingBot();
    // 监听窗口大小-设置表格滚动底部距离
    window.onresize = function () {
      if (document.querySelector(".el-table__body")) {
        if (window.innerWidth <= 1780) {
          let tbody = document.querySelector(".el-table__body");
          tbody.style.paddingBottom = "100px";
        } else {
          let tbody = document.querySelector(".el-table__body");
          tbody.style.paddingBottom = "0px";
        }
      }
    };
  },

  methods: {
    // 初始化 表格滚动底部距离
    paddingBot() {
      if (document.querySelector(".el-table__body")) {
        if (window.innerWidth <= 1780) {
          let tbody = document.querySelector(".el-table__body");
          tbody.style.paddingBottom = "100px";
        }
      }
    },
    //设置表格行的样式
    TableRow({ rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "statistics-warning-row";
      } else {
        return "";
      }
    },
    // 设置表格头样式
    thClass() {
      return "color:#64C3A4;font-size:18px;";
    },
    // 取消后重新获取
    alginGet() {
      if (this.getInLists) {
        this.getInLists();
      } else if (this.getOrderDetail) {
        this.getOrderDetail();
      }
    },

    // 页码更换事件
    currentChange(val) {
      this.pageNo = val;
      this.getInLists();
    },

    // 立即投保
    async buyInsure() {
      const { respCode, obj } = await getInsureId();
      if (respCode === 0) {
        console.log(obj);
        if (!obj.list.length) {
          this.$message("暂无可购买的险种");
          return;
        } else {
          this.insureInfo = SessionStorage.get("insureInfo");

          const res = await checkEnableInsure({
            insureId: obj.list.find((item) => {
              return item.id === this.insureInfo.id;
            }).id,
            companyId: this.companyId,
            farmId: this.farmId,
          });

          if (res && res.respCode == 0) {
            this.$router.push("/insure");
          }
        }
      }
    },
  },
};
